<div class="underlying-search">
  <web-components-asset-search type="underlying" (assetSelected)="underlyingSelected.emit($event)" />
</div>
